import { render, staticRenderFns } from "./summary-address.vue?vue&type=template&id=525de257&"
import script from "./summary-address.vue?vue&type=script&lang=js&"
export * from "./summary-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports